import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { AGENCY_PATH, RoleID } from '../common/Constants';
import { UserDataManager } from '../user/UserDataManager';
import { User } from '../models/user';
import { CompanyService } from '../services/company/company.service';

@Injectable({ providedIn: 'root' })
export class IoInsightAccessGuard implements CanActivate {
  constructor(
    private userDataManager: UserDataManager,
    private companyService: CompanyService,
    private router: Router,
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.userDataManager.user$.pipe(
      take(1),
      switchMap((user: User | undefined) => {
        if (!user || user.currentUserRole !== RoleID.companyAdmin) {
          return of(true);
        }
        return this.companyService.checkIsIOInsightEnabled().pipe(
          map((res) => this.isIoInsightEnabledFromResponse(res)),
          map((enabled) =>
            enabled ? true : this.router.createUrlTree([AGENCY_PATH]),
          ),
          catchError(() => of(this.router.createUrlTree([AGENCY_PATH]))),
        );
      }),
    );
  }

  private isIoInsightEnabledFromResponse(res: any): boolean {
    if (res?.success === false) {
      return false;
    }
    const d = res?.content?.data;
    if (typeof d?.ioInsight === 'boolean') {
      return d.ioInsight;
    }
    if (typeof res?.ioInsight === 'boolean') {
      return res.ioInsight;
    }
    return false;
  }
}
